import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import AlbumDate from '../../../../Date'

function AlbumItem({ album, goToAlbum }) {

  const { primary_photo_extras, title, id } = album
  const { url_m: imageUrl , datetaken } = primary_photo_extras
  const { _content: albumTitle } = title
  const date = new Date(datetaken.replace(/-/g, '/')) / 1000

  return (
    <div className="col s12 m6 l3">
      <div className="card">
        <div className="card-image">
          <Link onClick={() => goToAlbum(id)}>
            <div className="link"
                 style={{ backgroundImage: `url(${ imageUrl })`, height: '280px' }}/>
          </Link>
        </div>
        <div className="card-content">
          <p>
            <span className="video-title card-title truncate">{ albumTitle }</span>
            <AlbumDate date={ date }/>
          </p>
        </div>
        <div className="card-action">
          <Link onClick={() => goToAlbum(id)} className="link">Voir l'album</Link></div>
      </div>
    </div>
  )

}

const { func, object } = PropTypes
AlbumItem.propTypes = {
  goToAlbum: func,
  album: object
}

export default AlbumItem



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Albums/AlbumItem/AlbumItem.jsx
 **/